<template>
  <div class="ml-1">
    <TabelaCompraDepartamentos
      :cabecalhos_personalizado="cabecalhos"
      :height="height_tabela"
      ocultar_titulo
      ocultar_marcador_identacao
      ocultar_tela_cheia
      exibir_colunas_opcionais
      show-select
      :departamento="departamento_fake"
      :linhas_removidas="linhas_removidas"
      ocultar_filtros_topo
      :callback-nivel1="buscarTotalizadorPedidoCompra"
      :callback-nivel2="buscarCategoriasPedidoCompra"
      :qtd_niveis_expancao="2"
      :item-class="classesCssLinha"
      @itens-data-table="itens_grid = $event"
    >
      <template #prefixo.topo>
        <span class="mr-5 font-18">Categorias</span>
      </template>

      <template #append.topo>
        <ExcluirCategorias
          :categorias="categorias_selecionadas"
          @produto-excluido-carrinho="produtoExcluidoCarrinho(categorias_selecionadas)"
        >
          <template #botao="{callbackExclusao}">
            <v-badge v-show="categorias_selecionadas.length > 0" overlap color="white" class="ml-6">
              <template #badge>
                <span class="text-black">{{ categorias_selecionadas.length }}</span>
              </template>

              <v-btn color="red" dark small @click="callbackExclusao">
                <v-icon size="19" class="mr-1">mdi-cart</v-icon>
                excluir
              </v-btn>
            </v-badge>
          </template>
        </ExcluirCategorias>
      </template>

      <template #header.data-table-select>
        &nbsp;
      </template>

      <template #item.data-table-select="{item}">
        <div class="ml-2">
          <v-btn
            v-if="item.nivel_expancao ===  NIVEIS_DE_EXPANCAO.PRIMEIRO"
            icon small
            @click.stop="selecionarTodasCategorias(item)"
          >
            <v-icon v-if="categorias_selecionadas.length === 0">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else-if="categorias_selecionadas.length === CATEGORIAS.length" color="primary">mdi-checkbox-marked</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
          </v-btn>

          <v-btn v-else icon small @click.stop="selecionarCategoria(item)">
            <v-icon v-if="categoriaEstaSelecionada(item)" color="primary">mdi-checkbox-marked</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <template #item.grupo="{item}">
        {{ item.sigla_grupo }}
      </template>

      <template #item.nivel_servico="{item}">
        <NivelServico
          :nivel_servico="item.nivel_servico"
          :label="`categoria de ${item.nivel_servico}`.toLocaleLowerCase()"
        />
      </template>

      <template #item.idcategoria="{item}">
        {{ item.idcategoria || '-' }}
      </template>

      <template #item.cmm_peso="{item}">
        <span v-text="formatarValor(item.cmm_peso)" />
      </template>

      <template #item.estoque_pa="{item}">
        <span v-text="formatarValor(item.estoque_pa)" />
      </template>

      <template #item.estoque_pa_peso="{item}">
        <span v-text="formatarValor(item.estoque_pa_peso)" />
      </template>

      <template #item.estoque_mp_peso="{item}">
        <span v-text="formatarValor(item.estoque_mp_peso)" />
      </template>

      <template #item.cmm_pa="{item}">
        <span v-text="formatarValor(item.cmm_pa)" />
      </template>

      <template #item.estoque_peso="{item}">
        <div class="d-flex align-center">
          <span v-text="formatarValor(item.estoque_peso)" />
          <EstoquePorFilial :parametros="{...item, grupo: GRUPO_COMPRA}" tipo_filiais="lojas">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorFilial>
        </div>
      </template>

      <template #item.estoque_transito_peso="{item}">
        <div class="d-flex">
          {{ formatarValor(item.estoque_transito_peso) }}

          <PedidosPendente
            v-if="item.estoque_transito_peso > 0"
            :filtros="{...item, grupo: GRUPO_COMPRA}"
          >
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </PedidosPendente>
        </div>
      </template>

      <template #item.ultima_entrada="{item}">
        <span v-if="!item.data_ultima_entrada" class="text-gray-100">sem entrada</span>
        <v-tooltip v-else open-delay="500" top>
          <template #activator="{ on, attrs }">
            <div class="d-flex">
              <span v-bind="attrs" v-on="on" v-text="`há ${item.qtd_dias_ultima_entrada} dias`" />

              <UltimasCompras :filtros="{...item, grupo: GRUPO_COMPRA}">
                <template #topo-tabela>
                  <DescricaoNivelLinha :linha="item" />
                </template>
              </UltimasCompras>
            </div>
          </template>

          <span v-text="`A última entrada foi feita em ${item.data_ultima_entrada}`" />
        </v-tooltip>
      </template>

      <template #item.ultima_venda="{item}">
        <span v-if="!item.data_da_ultima_venda" class="text-gray-100">sem venda</span>

        <v-tooltip v-else open-delay="500" top>
          <template #activator="{ on, attrs }">
            <div class="d-flex">
              <span v-bind="attrs" v-on="on" v-text="`há ${item.qtd_dias_ultima_venda} dias`" />

              <VendasUltimosMeses :filtros="{...item, grupo: GRUPO_COMPRA}">
                <template #topo-corpo>
                  <DescricaoNivelLinha class="pt-3 pl-2" :linha="item" />
                </template>
              </VendasUltimosMeses>
            </div>
          </template>
          <span v-text="`A última venda foi feita em ${item.data_da_ultima_venda}`" />
        </v-tooltip>
      </template>

      <template #item.cobertura_estoque_futura="{item}">
        <span v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO">-</span>
        <CalculaCoberturaEstoqueFutura
            v-else
            :item="{
              estoque: item.estoque_peso,
              consumo_medio_mensal: item.cmm_peso,
              sugestao: item.quantidade,
              estoque_transito: item.estoque_transito_peso,
              tempo_medio_ressuprimento: item.prazo_medio_recebimento,
              multiplo_compra: 1
            }"
        />
      </template>

      <template #item.cobertura_geral_dias="{item}">
        <span v-text="`${formatarValorComCasas(item.cobertura_geral_dias, 1)} dias`" />
      </template>

      <template #item.prazo_medio_recebimento="{item}">
        <span v-text="`${formatarValorComCasas(item.prazo_medio_recebimento, 1)} dias`" />
      </template>

      <template #topo-lado-direito>
        <span class="font-weight-medium font-15 mr-2" v-text="`Quantidade de itens: ${CATEGORIAS.length}`" />
      </template>

      <template #item.quantidade_sugerida="{item}">
        <span
          v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO"
          v-text="formatarValor(LINHA_TOTALIZADORA.quantidade_sugerida)"
        />
        <span v-else v-text="formatarValor(item.quantidade_sugerida)" />
      </template>

      <template #item.sugestao_compra_preco_custo="{item}">
        <span
          v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO"
          v-text="formatarValorMonetario(LINHA_TOTALIZADORA.sugestao_compra_preco_custo)"
        />
        <span v-else v-text="formatarValorMonetario((item.quantidade || 0) * (item.preco_custo || 0))" />
      </template>

      <template #item.preco_custo="{item}">
        <div v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO" class="text-center mr-2">-</div>
        <PrecoDeCusto v-else :linha="item" @click.stop />
      </template>

      <template #item.quantidade="{item}">
        <div class="d-flex" @click.stop>
          <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO">
            <SugestaoDeCompra :linha="item" class="mr-2" />
            <ExcluirCategorias :categorias="[item]" @produto-excluido-carrinho="produtoExcluidoCarrinho([item])" />
          </template>

          <div v-else id="txt-sugestao-consolidada">
            {{ `${formatarValor(LINHA_TOTALIZADORA.quantidade)} ${item.idunidade_medida}` }}
          </div>
        </div>
      </template>

      <template #footer.bloco.esquerdo>
        <div class="mt-6 ml-1 font-12 d-flex align-center text-truncate">
          <span class="quadrado-15 bg-red" />
          <span class="ma-0 ml-1">Quantidade diferente da sugestão</span>
        </div>
      </template>
    </TabelaCompraDepartamentos>
  </div>
</template>

<script>
import {cabecalhos} from "./Cabecalhos.js";
import TabelaCompraDepartamentos from "../../../../utils/dataTable/sysDataTableDepartamentos/Index.vue";
import NivelServico from "../../../../utils/dataTable/sysDataTableDepartamentos/Componentes/NivelServico";
import Responsividade from "../../../../../helpers/ResponsiveHeight.js";
import {buscarTotalizadorCategoriasPedidoCompraMateriaPrima, buscarCategoriasPedidoCompraMateriaPrima} from '@/api/compras/MateriaPrima';
import {mapGetters} from "vuex";
import {formatarValor, formatarValorMonetario, formatarValorComCasas} from "@/helpers";
import {NIVEIS_DE_EXPANCAO} from "../../../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao";
import CalculaCoberturaEstoqueFutura from "@/components/compra/CalculaCoberturaEstoqueFutura.vue";
import EstoquePorFilial from "../DetalhesCategoria/Tabela/EstoquePorFilial.vue";
import PrecoDeCusto from "./AcoesTabela/PrecoDeCusto";
import SugestaoDeCompra from "./AcoesTabela/SugestaoDeCompra.vue";
import ExcluirCategorias from "./AcoesTabela/ExcluirCategorias";
import PedidosPendente from "../DetalhesCategoria/Tabela/PedidosPendente.vue";
import UltimasCompras from "../DetalhesCategoria/Tabela/UltimasCompras.vue";
import VendasUltimosMeses from "../DetalhesCategoria/Tabela/VendasUltimosMeses.vue";
import DescricaoNivelLinha from "../Helpers/DescricaoNivelLinha.vue";

const linha_totalizadora_padrao = {
  sugestao_compra_preco_custo: 0,
  quantidade_sugerida: 0,
  quantidade: 0
};

export default {
  name: "TabelaProdutos",
  mixins: [Responsividade],
  components: {
    TabelaCompraDepartamentos,
    NivelServico,
    PrecoDeCusto,
    SugestaoDeCompra,
    ExcluirCategorias,
    PedidosPendente,
    UltimasCompras,
    VendasUltimosMeses,
    CalculaCoberturaEstoqueFutura,
    EstoquePorFilial,
    DescricaoNivelLinha
  },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    departamento_fake: 1,
    linhas_removidas: [],
    cabecalhos,
    itens_grid: [],
    NIVEIS_DE_EXPANCAO,
    categorias_selecionadas: []
  }),
  computed: {
    ...mapGetters({
      'GRUPO_COMPRA': 'usuario/getGrupoCompras'
    }),
    height_tabela() {
      return parseInt(this.alturaDaJanela - 155);
    },
    LINHA_TOTALIZADORA() {
      const callback = (a, b) => {
        if (b.nivel_expancao !== NIVEIS_DE_EXPANCAO.SEGUNDO) return a;

        a.sugestao_compra_preco_custo += Number(b.quantidade * b.preco_custo) || 0;
        a.quantidade_sugerida += Number(b.quantidade_sugerida || 0);
        a.quantidade += Number(b.quantidade || 0);
        return a;
      }

      return this.itens_grid.reduce(callback, {...linha_totalizadora_padrao});
    },
    CATEGORIAS() {
      return this.itens_grid.filter(item => item.nivel_expancao ===  NIVEIS_DE_EXPANCAO.SEGUNDO)
    }
  },
  methods: {
    formatarValor,
    formatarValorMonetario,
    formatarValorComCasas,
    async buscarTotalizadorPedidoCompra() {
      if (!this.pedido.id) return null;

      const total = await buscarTotalizadorCategoriasPedidoCompraMateriaPrima(this.pedido.id);
      total.linha_totalizadora = true;

      return this.formatoLinha(total);
    },
    async buscarCategoriasPedidoCompra() {
      const categorias = await buscarCategoriasPedidoCompraMateriaPrima(this.pedido.id);
      return categorias.map(this.formatoLinha);
    },
    formatoLinha(linha) {
      // iddepartamento e idsecao são necessarios para uso interno do grid
      linha.iddepartamento = this.departamento_fake;
      linha.idsecao = this.departamento_fake;
      linha.id_pedido = this.pedido.id;
      return linha;
    },
    produtoExcluidoCarrinho(produtos) {
      this.linhas_removidas.push(...produtos);
      this.categorias_selecionadas = [];
    },
    classesCssLinha(linha) {
      if (linha.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO) return {};

      return {
        'text-red': Number(linha.quantidade) !== Number(linha.quantidade_sugerida),
        'sys-data-table-blue-linha-ativa': this.cate,
      }
    },
    categoriaEstaSelecionada(categoria) {
      const callback = item => item.idcategoria === categoria.idcategoria;
      return this.categorias_selecionadas.some(callback);
    },
    selecionarCategoria(categoria) {
      if (! this.categoriaEstaSelecionada(categoria)) {
        this.categorias_selecionadas.push(categoria);
        return;
      }

      const callback = item => item.idcategoria !== categoria.idcategoria;
      this.categorias_selecionadas = this.categorias_selecionadas.filter(callback);
    },
    selecionarTodasCategorias() {
      if (this.categorias_selecionadas.length === this.CATEGORIAS.length) {
        this.categorias_selecionadas = [];
        return;
      }

      this.categorias_selecionadas = this.CATEGORIAS;
    }
  }
}
</script>

<style scoped>
#txt-sugestao-consolidada {
  text-align: center;
  width: 128px;
}
</style>
